"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueDraggableResizable = _interopRequireDefault(require("vue-draggable-resizable"));
var _default = exports.default = {
  name: 'ReziableTitle',
  components: {
    VueDraggableReziable: _vueDraggableResizable.default
  },
  inject: ['columns'],
  computed: {
    column() {
      return this.columns().find(item => (item.dataIndex || item.key) === this.$attrs.key);
    }
  },
  methods: {
    handleDragging(x) {
      this.column.width = Math.max(x, 1);
    }
  }
};